var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5132 21 21 16.5132 21 11C21 5.48684 16.5132 1 11 1C5.48684 1 1 5.48684 1 11C1 16.5132 5.48684 21 11 21ZM11 2.05263C15.9342 2.05263 19.9474 6.0657 19.9474 11C19.9474 15.9343 15.9343 19.9474 11 19.9474C6.0657 19.9474 2.05263 15.9343 2.05263 11C2.05263 6.0657 6.0657 2.05263 11 2.05263Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1897 11.5256H15.2108C15.5003 11.5256 15.7371 11.2888 15.7371 10.9993C15.7371 10.7098 15.5003 10.473 15.2108 10.473H11.2635V5.20986C11.2635 4.92038 11.0267 4.68359 10.7372 4.68359C10.4477 4.68359 10.2109 4.92039 10.2109 5.20986V10.5468C10.2108 11.0863 10.6502 11.5257 11.1897 11.5257V11.5256Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconBlack);
export default __webpack_public_path__ + "static/media/clockIconBlack.b3764f85703a3f117573543ccc655e52.svg";
export { ForwardRef as ReactComponent };